(function ($) {
  var featuredProductCarouselFormatterV1 = {
    init: function (context, settings) {
      if ($.isFunction($.fn.flexslider)) {
        $('.featured-product-carousel-formatter-v1').once('featured-product-carousel-formatter-v1-flexslider').each(function () {
          var thisFormatter = $(this);
          var product = thisFormatter.find('.featured-product-carousel-sku');
          var smoosh = product.find('.smoosh');
          var quoteSlide = thisFormatter.find('.quote-slide');
          var accentColor = product.find('.shade-box').attr('data-skushade');

          if (site.spp) {
            if (!site.spp.globalStyleOverrides || !site.spp.globalStyleOverrides.color) {
              thisFormatter.find('h2').css('color', accentColor);
              product.find('.button').css('background-color', accentColor);
            }
          } else {
            thisFormatter.find('h2').css('color', accentColor);
            product.find('.button').css('background-color', accentColor);
          }

          if (quoteSlide.length > 0) {
            quoteSlide.prepend(smoosh);
          }

          var flexsliderID = thisFormatter.find('.flexslider').attr('id');
          var flexslider = $('#' + flexsliderID);
          var flexsliderDir = flexslider.data('direction');
          var rtl = flexsliderDir && flexsliderDir == 'rtl' ? true : false;
          var slideshow = false;

          if (flexslider.hasClass('flexslider-slideshow')) {
            slideshow = true;
          }

          flexslider.fitVids().flexslider({
            animation: 'slide',
            before: function (slider) {
            // stop video
              var currentSlide = slider.slides.eq(slider.currentSlide);
              var currentFrame = currentSlide.find('iframe');
              var currentFrameSrc = currentFrame.attr('src');

              currentFrame.attr('src', '');
              currentFrame.attr('src', currentFrameSrc);
            },
            itemMargin: 0,
            itemWidth: 580,
            minItems: 1,
            maxItems: 1,
            slideshow: slideshow,
            video: true,
            move: 1,
            animationLoop: true,
            rtl: rtl
          });
        });
      }
    }
  };

  $(window).on('load', function() {
    featuredProductCarouselFormatterV1.init();
  });
})(jQuery);
